import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ManualMerchantPage } from './manual-merchant';

@NgModule({
  declarations: [
    ManualMerchantPage,
  ],
  imports: [
    IonicPageModule.forChild(ManualMerchantPage),
    TranslateModule.forChild()
  ],
})
export class ManualMerchantPageModule {}



// WEBPACK FOOTER //
// ./src/pages/manual-merchant/manual-merchant.module.ts